import { useCallback } from 'react';
import type AgentApiAiJobSearchRunsResult from '@/types/serializers/AgentApiAiJobSearchRunsResult';
import RecommendationCard from './RecommendationCard';

type Props = {
  results: AgentApiAiJobSearchRunsResult[];
  /** 選択中の result.id Set */
  selectedIds: Set<number>;
  /** 選択 Set を更新するハンドラ */
  onSelectedIdsChange: (next: Set<number>) => void;
};

/** AI推薦結果リスト */
export default function RecommendationList({ results, selectedIds, onSelectedIdsChange }: Props) {
  const handleToggleSelect = useCallback(
    (resultId: number) => {
      const next = new Set(selectedIds);
      if (next.has(resultId)) {
        next.delete(resultId);
      } else {
        next.add(resultId);
      }
      onSelectedIdsChange(next);
    },
    [selectedIds, onSelectedIdsChange]
  );

  if (results.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-placeholder">
        <p className="text-sm">推薦結果が見つかりませんでした</p>
        <p className="mt-2 text-xs">候補者の情報を追加して再試行してください</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4" role="list" aria-label="AIおすすめ求人リスト">
      {results.map((result) => (
        <div key={result.id} role="listitem">
          <RecommendationCard
            result={result}
            isSelected={selectedIds.has(result.id)}
            onToggleSelect={handleToggleSelect}
          />
        </div>
      ))}
    </div>
  );
}
